// Rating
import Icon from 'components/common/Icon';
import React from 'react';
import cn from 'classnames';
import styles from './Rating.module.sass';

export interface RatingProps {
  rating?: number;
  className?: string;
}

const Rating: React.FC<RatingProps> = ({ rating = 5, className }) => {
  const roundedRating = rating.toFixed(1);

  return (
    <div className={cn(styles.rating, className)}>
      {Array.from({ length: 5 }).map((_, index) => {
        const filled = Number(roundedRating) >= index + 1;
        return (
          <Icon
            key={`star-${index}`}
            name={filled ? 'star' : 'star-outline'}
            size={18}
          />
        );
      })}
      <p>({roundedRating})</p>
    </div>
  );
};

export default Rating;
